import {Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList,} from '@angular/core';
import {FormControl} from '@angular/forms';
import {RcRadioComponent} from './rc-radio.component';
import {RcFormControlAbstract} from '../rc-form-control-abstract/rc-form-control-abstract';

/**
 * Rc Radios component
 *
 * @example
 * // in your component define the radios items
 * public radioItems: any[] = [
 *   {
 *       value: 1,
 *       selected: false,
 *   },
 *   {
 *       value: 2,
 *       selected: false,
 *   },
 *   {
 *       value: 3,
 *       selected: false,
 *   },
 *   ];
 *
 * // in your template call component
 * <lib-rc-radios [elementId]="'myRadioButtonID'" [items]="radioItems" [radiosName]="'myRadiosName'">
 *   <lib-rc-radio>radio 1</lib-rc-radio>
 *   <lib-rc-radio>radio 2</lib-rc-radio>
 *   <lib-rc-radio>radio 3</lib-rc-radio>
 * </lib-rc-radios>
 *
 */
@Component({
    selector: 'lib-rc-radios',
    template: `<div class="rc-radios-control-wrapper">
  <div [ngClass]="{'custom-controls-stacked': isVertical}" class="rc-radios-items-wrapper {{className}}">
    <ng-container *ngFor="let radio of radios; let i = index">
        <label class="custom-control custom-radio">
          <input (keydown)="handleKeyDown($event, items[i])" class="rc-radios-radio-input custom-control-input" [formControl]="control"
                 (change)="onChange($event)" attr.aria-describedby="{{getAriaDescribedBy()}}"
                 [attr.disabled]="_disabled"
                 [checked]="isChecked(items[i])"
                 [value]="items[i].value"
                 id="{{elementId}}_{{items[i].value}}"
                 [attr.name]="radiosName"
                 [name]="radiosName" type="radio">
          <span class="rc-radios-radio-item-content-wrapper" (click)="handleRadioClick(items[i])">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">
              <ng-container [ngTemplateOutlet]="radio.signleRadioContent"></ng-container>
            </span>
          </span>
        </label>
    </ng-container>
  </div>
  <div id="{{errorElementId}}" role="alert" class="invalid-feedback-message" *ngIf="errorMsg">{{ errorMsg }}</div>
</div>`,
    styles: [``]
})
export class RcRadiosComponent extends RcFormControlAbstract implements OnInit {

    /**
     * Will be insert into the DOM as radios name
     */
    @Input() radiosName: string;

    /**
     * Array of radio items
     */
    @Input() items: any[];

    /**
     * display radios vertical or horizontal
     */
    @Input() isVertical: boolean = true;

    /**
     * allow deselect
     */
    @Input() allowDeselect: boolean = false;


    /**
     * the child components, will be rendered aside to each radio item by index
     */
    @ContentChildren(RcRadioComponent) radios: QueryList<RcRadioComponent>;

    isChecked(radio) {
        return this.control.value === radio.value;
    }

    handleKeyDown($event, radioItem) {
        if ($event.keyCode === 32) {
            if (this.allowDeselect) {
                if (this.isChecked(radioItem)) {
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.deselectRadios();
                }
            }
        }
    }

    handleRadioClick(radioItem) {
        if (this.allowDeselect) {
            if (this.isChecked(radioItem)) {
                this.deselectRadios();
            }
        }
    }

    deselectRadios() {
        setTimeout(() => {
            this.control.setValue(null);
        }, 0);
        this.onChange(null);
    }
}



